import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "restAddress",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-6" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "solrCollection",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field p-col-12" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "restRequestBody",
  class: "kn-material-input-label"
}
const _hoisted_11 = { class: "p-field p-col-12" }
const _hoisted_12 = { class: "p-float-label" }
const _hoisted_13 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_14 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_15 = {
  for: "restJsonPathItems",
  class: "kn-material-input-label"
}
const _hoisted_16 = { class: "p-field-checkbox" }
const _hoisted_17 = { for: "binary" }
const _hoisted_18 = { class: "p-field-checkbox" }
const _hoisted_19 = { for: "binary" }
const _hoisted_20 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_21 = { class: "p-field p-col-4" }
const _hoisted_22 = { class: "p-float-label" }
const _hoisted_23 = {
  for: "restOffset",
  class: "kn-material-input-label"
}
const _hoisted_24 = { class: "p-col-4" }
const _hoisted_25 = { class: "p-float-label" }
const _hoisted_26 = {
  for: "restFetchSize",
  class: "kn-material-input-label"
}
const _hoisted_27 = { class: "p-col-4" }
const _hoisted_28 = { class: "p-float-label" }
const _hoisted_29 = {
  for: "restMaxResults",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Card = _resolveComponent("Card")
  const _component_RequestHeadersTable = _resolveComponent("RequestHeadersTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_JsonPathTable = _resolveComponent("JsonPathTable")
  const _component_JsonItemsHelpDialog = _resolveComponent("JsonItemsHelpDialog")
  const _component_DirectAttributesHelpDialog = _resolveComponent("DirectAttributesHelpDialog")
  const _component_NgsiHelpDialog = _resolveComponent("NgsiHelpDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-m-2" }, {
      content: _withCtx(() => [
        _createVNode("form", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _createVNode(_component_InputText, {
                id: "restAddress",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.restAddress.$invalid && _ctx.v$.dataset.restAddress.$dirty
                            }],
                type: "text",
                modelValue: _ctx.v$.dataset.restAddress.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.restAddress.$model = $event)),
                modelModifiers: { trim: true },
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.restAddress.$touch())),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.datasetManagement.restAddress')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.dataset.restAddress,
              additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.restAddress') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_InputText, {
                id: "solrCollection",
                class: "kn-material-input",
                modelValue: _ctx.dataset.solrCollection,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataset.solrCollection = $event)),
                modelModifiers: { trim: true },
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.datasetManagement.solrCollection')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("span", _hoisted_9, [
              _createVNode(_component_InputText, {
                id: "restRequestBody",
                class: "kn-material-input",
                maxLength: "2000",
                modelValue: _ctx.dataset.restRequestBody,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dataset.restRequestBody = $event)),
                modelModifiers: { trim: true },
                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.datasetManagement.restRequestBody')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("span", _hoisted_12, [
              _createVNode(_component_Dropdown, {
                id: "restHttpMethod",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.restHttpMethod.$invalid && _ctx.v$.dataset.restHttpMethod.$dirty
                            }],
                options: _ctx.httpMethods,
                optionLabel: "value",
                optionValue: "value",
                modelValue: _ctx.v$.dataset.restHttpMethod.$model,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.dataset.restHttpMethod.$model = $event)),
                onBeforeShow: _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.dataset.restHttpMethod.$touch()))
              }, null, 8, ["options", "modelValue", "class"]),
              _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('managers.datasetManagement.restHttpMethod')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.dataset.restHttpMethod,
              additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.datasetManagement.restHttpMethod')
                        }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_RequestHeadersTable, { selectedDataset: _ctx.selectedDataset }, null, 8, ["selectedDataset"]),
    _createVNode(_component_Card, { class: "p-mt-3" }, {
      content: _withCtx(() => [
        _createVNode("form", _hoisted_14, [
          _createVNode("div", {
            class: "p-col-12 p-field",
            style: _ctx.restDescriptor.style.infoColumnsContainer
          }, [
            _createVNode("span", {
              class: "p-float-label",
              style: _ctx.restDescriptor.style.maxWidth
            }, [
              _createVNode(_component_InputText, {
                id: "restJsonPathItems",
                class: "kn-material-input",
                style: _ctx.restDescriptor.style.maxWidth,
                modelValue: _ctx.dataset.restJsonPathItems,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.dataset.restJsonPathItems = $event)),
                modelModifiers: { trim: true },
                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["style", "modelValue"]),
              _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('managers.datasetManagement.restJsonPathItems')), 1)
            ], 4),
            _createVNode(_component_Button, {
              icon: "fas fa-info-circle",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.jsonItemsHelpVisible = true))
            })
          ], 4),
          _createVNode("div", {
            class: "p-col-12",
            style: _ctx.restDescriptor.style.infoColumnsContainer
          }, [
            _createVNode("span", _hoisted_16, [
              _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('managers.datasetManagement.restDirectlyJSONAttributes')) + ": ", 1),
              _createVNode(_component_Checkbox, {
                id: "binary",
                class: "p-ml-2",
                modelValue: _ctx.dataset.restDirectlyJSONAttributes,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dataset.restDirectlyJSONAttributes = $event)),
                binary: true,
                onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_Button, {
              icon: "fas fa-info-circle",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.directAttributesHelpVisible = true))
            })
          ], 4),
          _createVNode("div", {
            class: "p-col-12",
            style: _ctx.restDescriptor.style.infoColumnsContainer
          }, [
            _createVNode("span", _hoisted_18, [
              _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('managers.datasetManagement.restNGSI')) + ": ", 1),
              _createVNode(_component_Checkbox, {
                id: "binary",
                class: "p-ml-2",
                modelValue: _ctx.dataset.restNGSI,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.dataset.restNGSI = $event)),
                binary: true,
                onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_Button, {
              icon: "fas fa-info-circle",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.ngsiHelpVisible = true))
            })
          ], 4)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_JsonPathTable, { selectedDataset: _ctx.selectedDataset }, null, 8, ["selectedDataset"]),
    _createVNode(_component_Card, { class: "p-mt-3" }, {
      content: _withCtx(() => [
        _createVNode("form", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            _createVNode("span", _hoisted_22, [
              _createVNode(_component_InputText, {
                id: "restOffset",
                type: "number",
                class: "kn-material-input",
                modelValue: _ctx.dataset.restOffset,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.dataset.restOffset = $event)),
                modelModifiers: { trim: true },
                onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('managers.datasetManagement.restOffset')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_24, [
            _createVNode("span", _hoisted_25, [
              _createVNode(_component_InputText, {
                id: "restFetchSize",
                type: "number",
                class: "kn-material-input",
                modelValue: _ctx.dataset.restFetchSize,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.dataset.restFetchSize = $event)),
                modelModifiers: { trim: true },
                onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('managers.datasetManagement.restFetchSize')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_27, [
            _createVNode("span", _hoisted_28, [
              _createVNode(_component_InputText, {
                id: "restMaxResults",
                type: "number",
                class: "kn-material-input",
                modelValue: _ctx.dataset.restMaxResults,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.dataset.restMaxResults = $event)),
                modelModifiers: { trim: true },
                onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('managers.datasetManagement.restMaxResults')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_JsonItemsHelpDialog, {
      visible: _ctx.jsonItemsHelpVisible,
      onClose: _cache[25] || (_cache[25] = ($event: any) => (_ctx.jsonItemsHelpVisible = false))
    }, null, 8, ["visible"]),
    _createVNode(_component_DirectAttributesHelpDialog, {
      visible: _ctx.directAttributesHelpVisible,
      onClose: _cache[26] || (_cache[26] = ($event: any) => (_ctx.directAttributesHelpVisible = false))
    }, null, 8, ["visible"]),
    _createVNode(_component_NgsiHelpDialog, {
      visible: _ctx.ngsiHelpVisible,
      onClose: _cache[27] || (_cache[27] = ($event: any) => (_ctx.ngsiHelpVisible = false))
    }, null, 8, ["visible"])
  ], 64))
}